import React from 'react';
import { CheckIcon } from 'lucide-react';
import { BOX_IMAGE, CHECKOUT_URL, PRODUCT_NAME, TOPIC_LINE, systemFeatures } from '../data/atlante';
export function SystemSection() {
  return <section className="border-y-4 border-navy bg-white px-4 py-5 sm:py-7" data-id="element-179" data-mp="3bidf2dt104at">
      <div className="mx-auto max-w-4xl" data-id="element-180" data-mp="36jsg0hpifqny">
        <h2 className="text-center text-xl leading-tight text-navy sm:text-2xl" data-id="element-181" data-mp="36j0k15s03qx5">
          IL SISTEMA VISIVO COMPLETO 6-IN-1
        </h2>

        <div className="mt-3 grid items-center gap-4 sm:grid-cols-2" data-id="element-182" data-mp="31mjwodsmlgl4">
          <a href={CHECKOUT_URL} className="block" data-id="element-183" data-mp="2wsfpbtfg76ji">
            <img src={BOX_IMAGE} alt="I sei moduli di ATLANTE VISIVO DI PROTESI DENTALE™" className="mx-auto w-full max-w-[260px] drop-shadow-xl transition-transform duration-200 ease-soft hover:scale-[1.02]" data-id="element-184" data-mp="2ss5heb83i620" />
          </a>

          <div data-id="element-185" data-mp="2iw25wercsv2e">
            <p className="font-display text-lg font-extrabold uppercase leading-none tracking-tight text-navy sm:text-xl" data-id="element-186" data-mp="2dvej65a5r0dz">
              🦷 {PRODUCT_NAME}
            </p>
            <p className="mt-1 font-display text-[11px] font-extrabold uppercase tracking-wide text-gold sm:text-xs" data-id="element-187" data-mp="13x4zc2561na4">
              Risorse visuali pronte da consultare per i professionisti della
              protesi dentale
            </p>
            <p className="mt-1 text-[11px] font-bold uppercase tracking-wide text-slate2" data-id="element-188" data-mp="yzlhytd68udy">
              {TOPIC_LINE}
            </p>

            <ul className="mt-2.5 space-y-1" data-id="element-189" data-mp="1mq8u5qu4e66b">
              {systemFeatures.map(feature => <li key={feature} className="flex items-start gap-1.5 text-[13px] font-semibold leading-snug text-navy" data-id="element-190" data-mp="1roaf6hb3wfkf">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-green" aria-hidden="true" data-id="element-191" data-mp="1hpl69e16u5gb" />
                  {feature}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}